import MiniProgramPage from 'D:/小小程序员/项目/medical-management/OPO-uni/pagesSub/payment/detail.vue'
wx.createPage(MiniProgramPage)